import * as React from 'react'
import styled, { css } from 'styled-components'
import { Text } from './Font'
import { colors } from './helpers'
import { Flex } from './BuildingBlocks'

const StyledButton = styled.button`
  border: none;
  background-color: ${(props) => props.bg};
  ${(props) => (props.width ? `width: ${props.width};` : '')}
  border-radius: 8px;
  height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.yellowHover};
  }
`

const Button = (props) => {
  const { iconRight, label } = props
  return (
    <StyledButton {...props}>
      <Flex justifyContent="center" alignItems="center">
        <Text mr={iconRight ? '8px' : '0px'}>{label}</Text>
        {iconRight ? iconRight : null}
      </Flex>
    </StyledButton>
  )
}

export default Button
